<p-select [options]="lastInfoTemplate" [(ngModel)]="templateSelectionVar" optionLabel="templateTitle" placeholder="Select a Template" (onChange)="textAreaFiller()"/>
